module.exports = __webpack_public_path__ + "static/media/hut-thumb.ea2ed838.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/projects/hut-thumb.png
// module id = 181
// module chunks = 0